import { addDays as addDaysFns, sub, toDate } from 'date-fns';
import dayjs from 'dayjs';

export const SERVER_FORMAT_DATE = 'YYYY-MM-DD';

export const DATE_FORMAT = 'MM/DD/YY';
export const DATE_LONG_FORMAT = 'MM/DD/YYYY';

export const TIME_FORMAT = 'H:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export const formatDate = (
  date: Date | string | null,
  dateTime = false,
  dateFormat = DATE_FORMAT
) => {
  const DATE_TIME_FORMAT = `${dateFormat} ${TIME_FORMAT}`;

  if (!date) {
    return '';
  }

  if (dateTime) {
    return dayjs(date).format(DATE_TIME_FORMAT);
  }

  return dayjs(date).format(dateFormat);
};

export const getLastDayOfMonth = (date: Date) => {
  const selectedDate = toDate(date);
  const month = selectedDate.getMonth();

  selectedDate.setFullYear(selectedDate.getFullYear(), month + 1, 0);
  selectedDate.setHours(0, 0, 0, 0);

  return selectedDate;
};

export const getPastDate = (
  daysToSubtract?: number,
  monthsToSubtract?: number,
  yearsToSubtract?: number
) => {
  return sub(new Date(), {
    days: daysToSubtract,
    months: monthsToSubtract,
    years: yearsToSubtract,
  });
};

export const addDays = (daysToAdd: number, dateString?: string) => {
  const date = dateString ? new Date(dateString) : new Date();

  date.setHours(0, 0, 0, 0);

  return addDaysFns(date, daysToAdd);
};
